document.addEventListener("DOMContentLoaded", function () {
    const logoBar = document.querySelector(".logo-bar");
    
    if (!logoBar) return;

    // Duplicate logo items for seamless looping
    const logoItems = Array.from(logoBar.children);
    logoItems.forEach(item => {
        let clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        logoBar.appendChild(clone);
    });

    // Apply scrolling animation
    let speed = 20; 
    let step = 1;
    function autoScroll() {
        if (logoBar.scrollLeft >= logoBar.scrollWidth / 2) {
            logoBar.scrollLeft = 0;
        } else {
            logoBar.scrollLeft += step;
        }
    }
    
    let scrollInterval = setInterval(autoScroll, speed);

    // Pause scrolling on hover
    logoBar.addEventListener("mouseenter", () => clearInterval(scrollInterval));
    logoBar.addEventListener("mouseleave", () => {
        scrollInterval = setInterval(autoScroll, speed);
    });
});